import { combineReducers } from "redux";
import SamplePageReducer from "./SamplePageReducer";
import LanguageReducer from "./LanguageReducer";
import DigitalDownloadReducer from "./DigitalDownloadReducer";

export default combineReducers({
   SamplePage: SamplePageReducer,
   Language: LanguageReducer,
   Download: DigitalDownloadReducer
});